import Button from 'antd/es/button';
import styled from 'styled-components';

export const SendGiftPageContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    gap: 64px;
    align-self: stretch;
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const StickerContainer = styled.div`
    display: flex;
    width: 160px;
    height: 160px;
    padding: 14.953px 34.064px 25.984px 34.072px;
    justify-content: center;
    align-items: center;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const GreenText = styled.span`
    color: ${({ theme }) => theme.colors.theme.success};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const NormalText = styled.span`
    color: ${({ theme }) => theme.colors.text.headings};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
`;

export const EmailButton = styled(Button)`
    display: flex;
    padding: 10px var(--Sizes---size-l, 24px);
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: var(--Sizes-borderRadiusInput, 32px);
    background: ${({ theme }) => theme.colors.theme.brandColor3} !important;
    color: ${({ theme }) => theme.colors.common.white} !important;
    border: none !important;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
`;

export const WhatsappButton = styled(Button)`
    display: flex;
    padding: 10px var(--Sizes---size-l, 24px);
    justify-content: center;
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
    align-self: stretch;
    border-radius: 32px;
    background: ${({ theme }) => theme.colors.theme.success} !important;
    color: ${({ theme }) => theme.colors.common.white} !important;
    border: none !important;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
`;

export const DividerContainer = styled.div`
    display: flex;
    height: 15px;
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
    align-self: stretch;
`;

export const StyledDivider = styled.div`
    height: 1px;
    flex: 1 0 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors.text.muted};
`;

export const DividerText = styled(NormalText)`
    color: ${({ theme }) => theme.colors.text.muted};
`;

export const CopyLinkButton = styled(Button)`
    display: flex;
    height: 44px;
    padding: 10px var(--Sizes---size-l, 24px);
    justify-content: center;
    align-items: center;
    gap: var(--Sizes---sise-s, 8px);
    background: transparent;
    color: ${({ theme }) => theme.colors.theme.brandColor3} !important;
    border: none;
`;



